<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p46"><span><a id="page_35"></a><a href="#/Contents#rp46">LENTIL SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This satisfying soup is good on a cold, snowy day.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 pound dry brown lentils</span></p>
<p class="hang"><span>1 cup finely chopped onion</span></p>
<p class="hang"><span>½ cup each: finely chopped celery and carrot</span></p>
<p class="hang"><span>2 quarts water</span></p>
<p class="hang"><span>1 large smoked pork hock</span></p>
<p class="hang"><span>2 teaspoons each: sugar, beef bouillon crystals</span></p>
<p class="hang"><span>¼ teaspoon dry mustard</span></p>
<p class="hang"><span>½ teaspoon dried thyme leaves</span></p>
<p class="hang"><span>Salt and cayenne pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in large saucepan; reduce heat and simmer, covered, until lentils are very tender and soup has thickened, about 45 minutes. Discard pork hock; skim fat from soup and season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 89</span></p>
<p class="per1"><span>% calories from fat: 12</span></p>
<p class="per1"><span>Protein (g): 6.7</span></p>
<p class="per1"><span>Carbohydrate (g): 16.5</span></p>
<p class="per1"><span>Fat (g): 1.4</span></p>
<p class="per1"><span>Saturated fat (g): 0.3</span></p>
<p class="per1"><span>Cholesterol (mg): 6.5</span></p>
<p class="per1"><span>Sodium (mg): 277</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0227.vue?35b782c6